import { Icon } from "@mui/material";

const Check = () => (
  <Icon
    baseClassName="material-symbols-outlined"
    sx={{ fontWeight: 300, fontSize: "1rem", verticalAlign: "text-bottom" }}
  >
    check
  </Icon>
);

export const consumerPlanData = {
  columns: [
    {
      label: "",
      target: "",
      scope: "row",
    },
    {
      label: "Free",
      target: "free",
      align: "center",
    },
    {
      label: "Stanza+",
      target: "plus",
      align: "center",
    },
  ],
  body: {
    "Calendar adds": {
      free: <>2</>,
      plus: <>Unlimited</>,
      explainer: "Stanza+ gets you unlimited access to our library of 60,000+ calendars—across sports, TV, movies, space launches, and more. Subscribe to as many as you like and keep everything in one place. No limits.",
      icon: 'all_inclusive'
    },
    "Cross-device sync": {
      free: <>Manual</>,
      plus: <>Automatic</>,
      explainer: "Calendar changes flow automatically across all your devices—no need to manually sync each device.",
      icon: 'sync'
    },
    "Event updates": {
      free: <>24 hrs</>,
      plus: <>~Real-time</>,
      explainer: "With Stanza+, get real-time changes pushed to your calendar as soon as they’re available—no waiting, no guesswork.",
      icon: 'update'
    },
    "Exclusive calendars": {
      free: <></>,
      plus: <Check />,
      explainer: "Only Stanza+ members get access to premium calendars—like expanded sports coverage, early releases, curated collections, and limited-edition drops.",
      icon: 'lock'
    },
    '"Last updated" timestamp': {
      free: <></>,
      plus: <Check />,
      explainer: "See a timestamp in every event telling you when your calendar was last synced so you know you're always looking at the latest version—no second guessing.",
      icon: 'access_time'
    },
    "Force refresh": {
      free: <></>,
      plus: <Check />,
      explainer: "Manually update your calendars with a single click if something feels out of date—great for peace of mind before a big game or event.",
      icon: 'refresh'
    },
    "Group calendars": {
      free: <></>,
      plus: <Check />,
      explainer: "Instead of subscribing to 10 different calendars and crowding your calendar app, just add them to a group and subscribe once. As you update the group—adding or removing calendars—your calendar app stays in sync automatically. Clean, simple, and clutter-free.",
      icon: 'folder'
    },
    "Recommendations": {
      free: <></>,
      plus: <Check />,
      explainer: "Get smart suggestions based on calendars you already follow—discover new calendars without having to search for them.",
      icon: 'trending_up'
    },
    "Add individual events": {
      free: <></>,
      plus: <Check />,
      explainer: "Don’t need the full calendar? Add just the event you want—cleaner, simpler, more intentional.",
      icon: 'file_download'
    },
    "Early access": {
      free: <></>,
      plus: <Check />,
      explainer: "Be the first to try new calendars, features, and experimental drops before they go live to the rest of the world.",
      icon: 'card_giftcard'
    },
    "Suggest new calendars": {
      free: <></>,
      plus: <Check />,
      explainer: "Have a calendar you wish existed? Stanza+ members can suggest it—and help shape what gets added next.",
      icon: 'lightbulb'
    },
  },
};
